import { Modal } from "../../../components/others/Modal";
import ImportEmployees from "./importEmployees";

type TProps = {
  show: boolean,
  urlTittle?: string,
  modalTitle?: string,
  onClose: Function

};

const ImportEmployeesModal = (
  { show,
    urlTittle,
    modalTitle,
    onClose
  }: TProps) => {
  const styles = "text-2xl text-red-500 font-bold";




  return (
    <Modal
      show={show}
      urlTittle={urlTittle}
      modalTitle={modalTitle}
      onClose={() => onClose && onClose}
      titleStyle={styles}
    >
      <ImportEmployees
        onClose={onClose}
      />

    </Modal>
  )
};

export default ImportEmployeesModal;
